import { Avatar, styled } from "@mui/material";

const StyledAvatar = styled(Avatar)`
  background-color: ${(props) => props.theme.colors.gray};
  color: ${(props) => props.theme.palette.common.white};
  font-weight: 600;
  font-size: 14px;
  width: 40px;
  height: 40px;
`;

type Props = {
  firstName: string;
  lastName: string;
  size?: number;
  imageUrl?: string | null;
};

const getInitials = (firstName: string, lastName: string): string => {
  const firstInitial = firstName?.charAt(0)?.toUpperCase() || "";
  const lastInitial = lastName?.charAt(0)?.toUpperCase() || "";
  return `${firstInitial}${lastInitial}`;
};

export const UserAvatar = ({
  firstName,
  lastName,
  size = 40,
  imageUrl,
}: Props): React.ReactNode => {
  const initials = getInitials(firstName, lastName);

  return (
    <StyledAvatar
      src={imageUrl ?? undefined}
      sx={{
        width: size,
        height: size,
      }}
    >
      {initials}
    </StyledAvatar>
  );
};
